import React, {useState, useEffect} from 'react';
import Data from './Data';

function App() {

  const url = 'https://jsonplaceholder.typicode.com/posts'

  const [showData, setShowData] = useState([]);

  const loadData = () => {
    fetch(url, {
      method: 'GET'
    })
    .then((res) => res.json())
    .then((data) => {

      if(data) {
        setShowData(data);
      }

    })
    .catch((err) => {
      console.log('Error fetching data: ', err);    

    });
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="container"> 

      <h5 style={{color: 'white', textAlign: 'center', height: '100px', justifyContent: 'center', display: 'flex', lineHeight: '100px', backgroundColor: 'Orange'}}> React Accordion </h5>

      <div className="row">

        {showData.map((item, index) => (
          <div className="col-xl-6-col-lg-6 col-md-6 col-sm-12" key={index}>
            <Data {...item}/>
          </div>
        ))}

      </div>
    </div>
  );
}

export default App;
